import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakcabs() {



const cardData =
{
  keyword: 'Pune to Ashtavinayak Cabs',

  heading: 'Lotus Cab: Pune to Ashtavinayak Cabs',

headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Ashtavinayak Cabs for devotees seeking a comfortable and well-planned pilgrimage to the eight sacred Ganpati temples of Maharashtra. Whether you are traveling with family, senior citizens, friends, or a religious group, we provide Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus options driven by professional chauffeurs experienced with the complete Ashtavinayak route. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, flexible tour packages, customized itineraries, and safe travel, Lotus Cabs ensures a peaceful, convenient, and spiritually fulfilling Ashtavinayak Darshan experience.",

  top: 'Top Ashtavinayak Temples to Visit with Lotus Cab',

topPlaces: [
    {
        title: "Mayureshwar Temple, Morgaon",
        description:
            "Mayureshwar Temple at Morgaon is regarded as the starting and concluding point of the sacred Ashtavinayak Yatra. Dedicated to Lord Ganesha in his Mayureshwar form, this ancient temple holds immense religious importance and attracts thousands of devotees every year. Its peaceful atmosphere, beautiful architecture, and spiritual significance make it the most important destination in the Ashtavinayak circuit."
    },
    {
        title: "Siddhivinayak Temple, Siddhatek",
        description:
            "Siddhivinayak Temple at Siddhatek is situated on the banks of the Bhima River and is one of the most revered Ashtavinayak temples. Devotees believe that Lord Ganesha fulfills sincere wishes and removes obstacles for those who offer prayers here. The serene surroundings and spiritual ambiance make it a memorable stop during the pilgrimage."
    },
    {
        title: "Ballaleshwar Temple, Pali",
        description:
            "Ballaleshwar Temple in Pali is the only Ashtavinayak temple named after a devotee of Lord Ganesha. The temple is deeply associated with the story of the young devotee Ballal and is visited by pilgrims seeking blessings for happiness, prosperity, and success. Its unique history and peaceful environment make it a significant religious destination."
    },
    {
        title: "Varad Vinayak Temple, Mahad",
        description:
            "Varad Vinayak Temple at Mahad is believed to bless devotees with prosperity, good fortune, and the fulfillment of heartfelt wishes. The temple's sacred lamp is said to have been burning continuously for many years, and its calm surroundings create a spiritually uplifting experience for visitors."
    },
    {
        title: "Chintamani Temple, Theur",
        description:
            "Chintamani Temple at Theur is one of the most prominent Ganesh temples near Pune and is dedicated to Lord Ganesha as the remover of worries and anxieties. Surrounded by peaceful landscapes, the temple attracts devotees who seek mental peace, wisdom, and divine blessings throughout the year."
    },
    {
        title: "Girijatmaj Temple, Lenyadri",
        description:
            "Girijatmaj Temple is uniquely located inside a series of ancient rock-cut caves on Lenyadri Hill and is the only Ashtavinayak temple situated on a mountain. Devotees climb a long flight of steps to reach the temple, where they enjoy magnificent valley views along with a deeply spiritual atmosphere dedicated to Lord Ganesha."
    },
    {
        title: "Vighnahar Temple, Ozar",
        description:
            "Vighnahar Temple at Ozar is dedicated to Lord Ganesha as the remover of obstacles and difficulties. The beautifully decorated temple is known for its golden dome, peaceful surroundings, and vibrant celebrations during Ganesh festivals, attracting devotees from across Maharashtra and India."
    },
    {
        title: "Mahaganapati Temple, Ranjangaon",
        description:
            "Mahaganapati Temple at Ranjangaon is the final temple in the traditional Ashtavinayak pilgrimage and is believed to represent the powerful form of Lord Ganesha. The temple is admired for its historical importance, impressive architecture, and religious significance, making it an essential destination for completing the sacred yatra."
    },
    {
        title: "Jejuri",
        description:
            "Jejuri, the famous temple town dedicated to Lord Khandoba, is often included in an Ashtavinayak tour from Pune. Known for its grand temple, long stone staircase, and vibrant Bhandara (turmeric) festival, Jejuri offers devotees an additional spiritual experience while traveling through Maharashtra's sacred pilgrimage circuit."
    },
    {
        title: "Bhuleshwar Temple",
        description:
            "Bhuleshwar Temple is an ancient hilltop Shiva temple located near Pune and is frequently visited along with the Ashtavinayak circuit. Renowned for its remarkable stone carvings, Hemadpanti architecture, and peaceful surroundings, the temple provides visitors with a unique combination of history, spirituality, and scenic beauty."
    }
],

  "services": [
    {
      "name": "Pune to Ashtavinayak Cab Service",
      "description": "Book Pune to Ashtavinayak cab service covering all eight sacred Ganpati temples with structured routing for efficient darshan. The total journey spans approximately 650–750 km depending on temple order and detours. Available for one-day express darshan or relaxed two-day spiritual tour. AC sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options ensure comfort for families and elderly devotees. Transparent per kilometer pricing includes base fare, driver allowance, tolls, and waiting time details. Professional drivers experienced in rural and temple routes ensure safe and timely travel across Maharashtra."
    },
    {
      "name": "Pune to Ashtavinayak One Day Cab",
      "description": "Choose Pune to Ashtavinayak one day cab for devotees seeking faster completion of the sacred circuit. Early departure ensures maximum temple coverage within limited time. Comfortable AC vehicles and experienced drivers help maintain schedule. Suitable for small family groups planning same-day darshan."
    },
    {
      "name": "Pune to Ashtavinayak Two Day Cab",
      "description": "Two-day cab service offers relaxed travel allowing proper darshan at each temple without rush. Overnight halt options near Lenyadri or Ozar can be planned. Ideal for senior citizens and large families."
    },
    {
      "name": "Pune to Ashtavinayak Innova Cab",
      "description": "Premium Innova Crysta cab provides spacious seating and comfortable suspension for long-distance temple travel. Suitable for families requiring extra luggage space."
    },
    {
      "name": "Pune to Ashtavinayak Ertiga Cab",
      "description": "Affordable Ertiga cab suitable for small groups seeking budget-friendly pilgrimage travel with AC comfort."
    },
    {
      "name": "Pune to Ashtavinayak Sedan Cab",
      "description": "Sedan cab option for economical pilgrimage travel with comfortable seating and efficient fuel economy."
    },
    {
      "name": "Pune to Ashtavinayak Tempo Traveller",
      "description": "Tempo Traveller service ideal for larger pilgrimage groups, temple committees, and corporate spiritual tours."
    },
    {
      "name": "Pune Airport to Ashtavinayak Cab",
      "description": "Direct pickup from Pune Airport for devotees arriving by flight and planning immediate temple darshan journey."
    }
  ],

  "tableData": [
    ["Pune to Ashtavinayak Cab Service", "Pune to Ashtavinayak One Day Cab"],
    ["Pune to Ashtavinayak Two Day Cab", "Pune to Ashtavinayak Innova Cab"],
    ["Pune to Ashtavinayak Ertiga Cab", "Pune to Ashtavinayak Sedan Cab"],
    ["Pune to Ashtavinayak Tempo Traveller", "Pune Airport to Ashtavinayak Cab"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Complete 8 Temple Coverage",
      "WhyChoosedescription": "Structured routing ensures all Ashtavinayak temples are covered efficiently."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear per kilometer billing with detailed fare breakdown."
    },
    {
      "WhyChooseheading": "Experienced Temple Route Drivers",
      "WhyChoosedescription": "Drivers familiar with rural roads and temple timings."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Sedan, SUV, Innova, and Tempo Traveller categories available."
    },
    {
      "WhyChooseheading": "Flexible 1–2 Day Plans",
      "WhyChoosedescription": "Customizable itinerary based on travel preference."
    },
    {
      "WhyChooseheading": "Senior Citizen Friendly Travel",
      "WhyChoosedescription": "Comfortable seating and relaxed scheduling."
    },
    {
      "WhyChooseheading": "Airport & PCMC Pickup",
      "WhyChoosedescription": "Convenient pickup across Pune and surrounding areas."
    },
    {
      "WhyChooseheading": "24/7 Booking Support",
      "WhyChoosedescription": "Round-the-clock assistance for planning pilgrimage."
    }
  ]
}









const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Ashtavinayak cab service?',
    answer: 'Yes, Lotus Cab offers dedicated Pune to Ashtavinayak cab services covering all eight sacred Ganpati temples with comfortable vehicles and experienced drivers.',
  },
  {
    question: 'Which temples are covered in the Ashtavinayak cab package?',
    answer: 'Our Pune to Ashtavinayak cab package covers Mayureshwar (Morgaon), Siddhivinayak (Siddhatek), Ballaleshwar (Pali), Varadvinayak (Mahad), Chintamani (Theur), Girijatmaj (Lenyadri), Vighnahar (Ozar), and Mahaganapati (Ranjangaon).',
  },
  {
    question: 'How many days are required for Ashtavinayak Darshan from Pune?',
    answer: 'The complete Ashtavinayak Darshan usually requires 2 to 3 days depending on the travel route, temple timings, and halt preferences.',
  },
  {
    question: 'What are the charges for Pune to Ashtavinayak cab booking?',
    answer: 'Cab charges depend on vehicle type, total distance, and number of travel days. Lotus Cab provides transparent package pricing with no hidden charges.',
  },
  {
    question: 'Which vehicles are suitable for Ashtavinayak trip?',
    answer: 'We offer Sedan cars for small families and spacious SUVs like Ertiga and Innova Crysta for group and comfortable pilgrimage travel.',
  },
  {
    question: 'Is the Ashtavinayak cab service suitable for senior citizens?',
    answer: 'Yes, Lotus Cab ensures smooth and flexible travel with comfortable seating and experienced drivers, making it ideal for senior citizens.',
  },
  {
    question: 'Are toll and driver allowance included in the package?',
    answer: 'Package details are clearly explained before booking. Toll, parking, and driver allowance are either included in the package or billed transparently as agreed.',
  },
  {
    question: 'Can I customize the Ashtavinayak itinerary?',
    answer: 'Yes, Lotus Cab allows itinerary customization based on your preferred temple sequence, travel pace, and stay duration.',
  },
  {
    question: 'Is advance booking recommended for Ashtavinayak Darshan?',
    answer: 'Yes, advance booking is recommended especially during festive seasons like Ganesh Chaturthi and weekends due to high demand.',
  },
  {
    question: 'How can I book Pune to Ashtavinayak cab with Lotus Cab?',
    answer: 'You can book by sharing your travel dates, passenger count, and vehicle preference to receive a detailed fare estimate and confirmed booking instantly.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Santosh Kulkarni',
    feedback: 'We booked Lotus Cab for Ashtavinayak Darshan from Pune. The driver guided us well and the trip was comfortable across all temples.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Archana Deshmukh',
    feedback: 'Excellent Ashtavinayak cab service by Lotus Cab. Clean Innova, transparent pricing, and very cooperative driver. Highly recommended for pilgrimage trips.',
    rating: 5,
  },
];











































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Ashtavinayak Cab Service",
"image": "https://lotuscab.com/assets/images/pune-to-ashtavinayak-cab.jpg",
"description": "Book Pune to Ashtavinayak Cab Service with Lotus Cab for a comfortable and spiritual pilgrimage tour. Visit all eight Ashtavinayak temples with safe, affordable, and reliable AC taxi service available 24x7 with experienced drivers.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7421"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹12/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-ashtavinayak-cab"
}
};











  return (
    <div>
      

<Helmet>
  <title>Pune to Ashtavinayak Cab Service | 8 Jyotirlinga Darshan Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Ashtavinayak Cab Service with Lotus Cab for a safe and comfortable pilgrimage tour. Visit all 8 Ashtavinayak temples with affordable one way and round trip taxi service, experienced drivers, and 24x7 support."
/>

<meta
 name="keywords"
 content="Pune to Ashtavinayak Cab, Ashtavinayak Cab Service Pune, Pune Ashtavinayak Tour Package, Ashtavinayak Darshan Cab Pune, Pune to 8 Ashtavinayak Temple Cab, Morgaon Siddhatek Theur Ranjangaon Lenyadri Ozar Mahad Pali Cab, Pune Pilgrimage Cab Service, Outstation Ashtavinayak Taxi Pune, One Day Ashtavinayak Cab Pune, Round Trip Ashtavinayak Cab, Affordable Ashtavinayak Cab Pune, Best Ashtavinayak Taxi Service, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/89.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakcabs;